var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-square-image"},[_c('div',{staticClass:"u-square-image-wrapper",style:(_vm.styles)},[(!!_vm.src)?[_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt}})]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }